module.exports = __webpack_public_path__ + "img/ic-next-arrow.6189d09d.svg";